import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
});

// Change title middleware
router.beforeEach((to, from, next) => {
  document.title = `E'Health & Beauty | ${to.meta.title || '404'}`;
  next();
});

export default router;
